// 特定のコースページでのみ実行されるスクリプト
(function() {
  // URLが指定されたパターンに一致する場合のみ実行
  // https://e-cycle.online/apps/ldt-course/course/任意の英数字 というパターンに対応
  const coursePagePattern = /https:\/\/e-cycle\.online\/apps\/ldt-course\/course\/[a-zA-Z0-9]+/;
  
  if (coursePagePattern.test(window.location.href)) {
    console.log('コースページが一致しました。データを収集して送信します。');
    
    // DOMがロードされた後に実行
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', sendToSpreadsheet);
    } else {
      // MutationObserverを使用して要素が表示されるのを待つ
      const observer = new MutationObserver((mutations) => {
        // 必要な要素が存在するか確認（進捗表示の新しいセレクタに対応）
        if (document.querySelector('.ldt-cr-course-progress') && 
            document.querySelector('.ldt-cr-firstName') && 
            document.querySelector('.ldt-cr-lastName')) {
          observer.disconnect();
          sendToSpreadsheet();
        }
      });
      
      // bodyの変更を監視
      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
      
      // 既に要素が存在する場合は直ちに実行
      if (document.querySelector('.ldt-cr-course-progress') && 
          document.querySelector('.ldt-cr-firstName') && 
          document.querySelector('.ldt-cr-lastName')) {
        sendToSpreadsheet();
      }
    }
  }
  
  function sendToSpreadsheet() {
    try {
      // 要素の取得
      const completedElements = document.querySelectorAll('.ldt-cr-nav-lesson div[title="未完了としてマーク"]');
      const uncompletedElements = document.querySelectorAll('div[title="完了としてマーク"]');
      const completeCount = completedElements.length;
      const uncompleteCount = uncompletedElements.length;
      
      let progress = "";
      // 新しいレイアウトに対応した進捗率の取得 - 修正バージョン
      const progressContainer = document.querySelector('.ldt-cr-course-progress');
      if (progressContainer) {
        // 直接最後の子要素を取得（div:last-childよりも確実）
        const children = progressContainer.children;
        if (children && children.length > 0) {
          const lastChild = children[children.length - 1];
          if (lastChild) {
            progress = lastChild.textContent.trim();
            console.log('Progress text from last child:', progress);
          }
        }
        
        // 上記方法で取得できなかった場合はプログレスバーのスタイルから取得
        if (!progress) {
          const progressBar = progressContainer.querySelector('.ldt-cr-bg-primary');
          if (progressBar && progressBar.style && progressBar.style.width) {
            progress = progressBar.style.width;
            console.log('Progress from style width:', progress);
          }
        }
        
        // デバッグ用にHTML構造をログ出力
        console.log('Progress container HTML:', progressContainer.outerHTML);
      } else {
        console.log('Progress container not found');
      }
      
      const firstName = document.querySelector('.ldt-cr-firstName')?.innerHTML || "";
      const lastName = document.querySelector('.ldt-cr-lastName')?.innerHTML || "";
      
      let course = "";
      const courseElement = document.querySelector('.ldt-cr-course-info-detail .ldt-cr-m-0');
      if (courseElement) {
        course = courseElement.innerHTML;
      }
      
      let registrationDate = "";
      const orderDateElement = document.querySelector('.order-date');
      if (orderDateElement) {
        registrationDate = orderDateElement.innerHTML;
      }
      
      // セッションストレージから情報を取得（前のスクリプトで格納したもの）
      const courseCompletedAtValue = sessionStorage.getItem('courseCompletedAt') || "";
      const courseCreatedAtValue = sessionStorage.getItem('courseCreatedAt') || "";
      const companyNameValue = sessionStorage.getItem('companyName') || "";
      
      // registrationDateの設定
      registrationDate = "";
      if (courseCreatedAtValue) {
        // "登録日: 2025/04/14" または "登録日: 2025年04月14日" のようなフォーマットから日付部分のみを抽出
        const dateMatch = courseCreatedAtValue.match(/(\d{4}\/\d{1,2}\/\d{1,2}|\d{4}年\d{1,2}月\d{1,2}日)/);
        if (dateMatch) {
          registrationDate = dateMatch[1];
        }
      }
      
      // 完了日を処理
      let completionDate = "";
      if (courseCompletedAtValue) {
        // "完了日: 2025年4月18日" のようなフォーマットから日付部分のみを抽出
        const dateMatch = courseCompletedAtValue.match(/(\d{4}\/\d{1,2}\/\d{1,2}|\d{4}年\d{1,2}月\d{1,2}日)/);
        if (dateMatch) {
          completionDate = dateMatch[1];
        }
      }

      // 時間とタイトルを計算する関数
      function sumTimes(elements) {
        let totalMinutes = 0;
        let totalSeconds = 0;
        let lessonTitles = []; // レッスンタイトルを格納する配列
        
        elements.forEach(element => {
          const lessonElement = element.closest('.ldt-cr-nav-lesson')
            ?.querySelector('.ldt-cr-nav-lesson-label span');
            
          if (lessonElement) {
            const lessonText = lessonElement.textContent;
            
            // タイトルと時間を分離して取得
            const titleMatch = lessonText.match(/(.*?)\s*\((\d+):(\d+)\)/);
            
            if (titleMatch) {
              // タイトルを配列に追加
              lessonTitles.push(titleMatch[1].trim());
              
              // 時間の計算
              totalMinutes += parseInt(titleMatch[2]);
              totalSeconds += parseInt(titleMatch[3]);
            }
          }
        });
        
        // 秒を分に繰り上げ
        totalMinutes += Math.floor(totalSeconds / 60);
        totalSeconds = totalSeconds % 60;
        
        // 分を時間に繰り上げ
        const hours = Math.floor(totalMinutes / 60);
        const minutes = totalMinutes % 60;
        
        // 時間とタイトルの情報を返すオブジェクト
        return {
          time: hours > 0 ? `${hours}時間${minutes}分${totalSeconds}秒` : `${minutes}分${totalSeconds}秒`,
          titles: lessonTitles.join(',') // カンマ区切りでタイトルを結合
        };
      }
      
      // 時間とタイトルの情報を取得
      const completedInfo = sumTimes(completedElements);
      const uncompletedInfo = sumTimes(uncompletedElements);
      
      // セッションストレージから情報を取得（前のスクリプトで格納したもの）
      const courseCompletedAt = sessionStorage.getItem('courseCompletedAt') || "";
      const courseCreatedAt = sessionStorage.getItem('courseCreatedAt') || "";
      const companyName = sessionStorage.getItem('companyName') || "";
      
      // データオブジェクトの作成
      const data = {
        firstName: firstName,
        lastName: lastName,
        completeCount: completeCount,
        uncompleteCount: uncompleteCount,
        completedTime: completedInfo.time,
        completedTitles: completedInfo.titles,
        uncompletedTime: uncompletedInfo.time,
        uncompletedTitles: uncompletedInfo.titles,
        progress: progress,
        timestamp: new Date().toISOString(),
        course: course,
        registrationDate: registrationDate,
        completionDate: completionDate,  // 完了日を追加
        courseCompletedAt: courseCompletedAtValue,
        courseCreatedAt: courseCreatedAtValue,
        companyName: companyNameValue
      };
      
      console.log('送信するデータ:', data);
      
      // POSTメソッドでデータを送信
      fetch('https://script.google.com/macros/s/AKfycbwGAmsjinaUwV7dQe-nMEPX1yWvuhKVyo9onLsKczB3KmmA6D37V2Ea6o9xeY3O0ZcJ/exec', {
        method: 'POST',
        headers: {
          'Content-Type': 'text/plain;charset=utf-8',
        },
        body: JSON.stringify(data)
      })
      .then(response => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.json();
      })
      .then(function(data) {
        console.log('成功:', data);
      })
      .catch(function(error) {
        console.log('エラー:', error);
      });
    } catch (error) {
      console.error('データ送信中にエラーが発生しました:', error);
    }
  }
})();